import { ICardElementWithChildren } from "backend/model/model";
import InitiativeHeading from "design/components/texts/InitiativeHeading";
import { getPropsFromContent, IDisplaySeries } from "design/types";
import React from "react";
import { formatDate, getDateFromMEAValue } from "utils/utils";
import useSlippageCardStyles from "./SlippageCardStyles";

type Props = {
  data?: ICardElementWithChildren;
  display: IDisplaySeries;
  dateDisplay: IDisplaySeries;
};

type Units = {
  d: string;
  w: string;
  y: string;
};

// TODO: modularize the units conversion
const slippageUnits: Units = {
  d: "Days",
  w: "Weeks",
  y: "Years",
};

const SlippageCard = (props: Props) => {
  const classes = useSlippageCardStyles();
  const { data, display, dateDisplay } = props;

  if (!data) {
    return null;
  }
  const content = getPropsFromContent(data, display);
  const dateContent = getPropsFromContent(data, dateDisplay);
  const n = Number(content.value);
  const sign = n > 0 ? "+" : "";

  const date = formatDate(
    getDateFromMEAValue(dateContent.value),
    dateContent.locale,
    true
  );

  return (
    <div className={classes.slippageContainer}>
      <InitiativeHeading>{content.title}</InitiativeHeading>

      <div className={classes.container}>
        <div className={classes.largeText}>
          <span className={classes.sign}>{sign}</span>
          {content.valuewithoutsymbol}
          <span className={classes.unit}>{content.unit}</span>
        </div>
        <div>
          <h3 className={classes.text}>{dateContent.title}</h3>
          <h3 className={classes.text}>{date}</h3>
        </div>
      </div>
    </div>
  );
};

export default SlippageCard;
